import teamsTableBg from '../assets/22.jpg';
import leadsTableBg from '../assets/21.jpg';
import contactsTableBg from '../assets/22.jpg';
import uploadsHistoryTableBg from '../assets/19.jpg';
import documentsTableBg from '../assets/24.jpg';

export const TABLE_BACKGROUNDS = {
  teams: teamsTableBg,
  leads: leadsTableBg,
  contacts: contactsTableBg,
  accounts: contactsTableBg,
  uploadsHistory: uploadsHistoryTableBg,
  documents: documentsTableBg,
};
